// Mock Partner API
export const partnerApi = {
  // Get leads for partner
  getLeads: async () => {
    return new Promise((resolve) => {
      setTimeout(() => {
        resolve({
          leads: [
            {
              id: 101,
              user: {
                name: 'Rajesh Kumar',
                phone: '+91 9876543210',
                avatar: 'https://randomuser.me/api/portraits/men/45.jpg',
              },
              service: 'Cleansing Therapy',
              status: 'pending_partner_acceptance',
              distance: 2.3,
              location: 'Indiranagar, Bangalore',
              preferredTime: 'morning',
              createdAt: new Date().toISOString(),
            },
            {
              id: 102,
              user: {
                name: 'Priya Singh',
                phone: '+91 9876543211',
                avatar: 'https://randomuser.me/api/portraits/women/65.jpg',
              },
              service: 'Cleansing Therapy',
              status: 'pending_partner_acceptance',
              distance: 4.1,
              location: 'Koramangala, Bangalore',
              preferredTime: 'afternoon',
              createdAt: new Date(Date.now() - 300000).toISOString(),
            },
          ],
        });
      }, 800);
    });
  },

  // Accept lead
  acceptLead: async (leadId) => {
    return new Promise((resolve) => {
      setTimeout(() => {
        resolve({
          success: true,
          booking: {
            id: leadId,
            service: 'Cleansing Therapy',
            status: 'accepted_by_partner',
            date: new Date(Date.now() + 86400000).toISOString(),
            user: {
              name: 'Rajesh Kumar',
              phone: '+91 9876543210',
            },
            location: 'Indiranagar, Bangalore',
            preferredTime: 'morning',
          },
          message: 'Lead accepted successfully',
        });
      }, 600);
    });
  },

  // Reject lead
  rejectLead: async (leadId) => {
    return new Promise((resolve) => {
      setTimeout(() => {
        resolve({
          success: true,
          message: 'Lead rejected',
        });
      }, 400);
    });
  },

  // Toggle availability
  toggleAvailability: async () => {
    return new Promise((resolve) => {
      setTimeout(() => {
        const available = Math.random() > 0.5;
        resolve({
          success: true,
          available,
          message: `You are now ${available ? 'available' : 'unavailable'}`,
        });
      }, 300);
    });
  },

  // Get partner stats
  getStats: async () => {
    return new Promise((resolve) => {
      setTimeout(() => {
        resolve({
          stats: {
            totalEarnings: 45600,
            completedSessions: 78,
            pendingBookings: 3,
            rating: 4.8,
            reviewCount: 156,
            responseRate: 98,
            thisMonthEarnings: 12400,
            thisMonthSessions: 21,
          },
        });
      }, 600);
    });
  },

  // Complete booking
  completeBooking: async (bookingId) => {
    return new Promise((resolve) => {
      setTimeout(() => {
        resolve({
          success: true,
          message: 'Booking marked as completed',
        });
      }, 400);
    });
  },
};

export default partnerApi;
